import { QueryClient, QueryClientConfig } from '@tanstack/react-query';

const registry = new Map<string, QueryClient>();

const defaultConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount: number, err: unknown) => {
        const status = (err as any)?.response?.status as number | undefined;
        if (status && status < 500 && status !== 429) return false;
        return failureCount < 3;
      },
      networkMode: 'online',
    },
    mutations: { networkMode: 'online' },
  },
};

export const createQueryClient = (config?: QueryClientConfig) =>
  new QueryClient({
    ...defaultConfig,
    ...config,
    defaultOptions: {
      ...defaultConfig.defaultOptions,
      ...config?.defaultOptions,
      queries: {
        ...defaultConfig.defaultOptions?.queries,
        ...config?.defaultOptions?.queries,
      },
      mutations: {
        ...defaultConfig.defaultOptions?.mutations,
        ...config?.defaultOptions?.mutations,
      },
    },
  });

export const getQueryClient = (scope: string = 'app', config?: QueryClientConfig) => {
  const existing = registry.get(scope);
  if (existing) return existing;
  const client = createQueryClient(config);
  registry.set(scope, client);
  return client;
};

export const destroyQueryClient = (scope: string = 'app') => {
  const client = registry.get(scope);
  if (!client) return;
  client.clear();
  registry.delete(scope);
};
